import * as React from "react"

import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"

import { Svg } from "styleguide/components"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconExpand = ({
  title = "Expand",
  color = "darkerRed",
  viewBoxWidth = 24,
  viewBoxHeight = 24,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <circle
        stroke={uiColorToBaseColor(color)}
        strokeWidth="2"
        fill="#FFFFFF"
        cx="12"
        cy="12"
        r="11"
      />
      <polygon
        fill={uiColorToBaseColor(color)}
        points="7 11 11 11 11 7 13 7 13 11 17 11 17 13 13 13 13 17 11 17 11 13 7 13"
      />
    </g>
  </Svg.Icon>
)

export default IconExpand
